module.exports = __webpack_public_path__ + "img/icon_box_3_2.d9586c18.png";